import { Navigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import SignupForm from "../../auth/SignupForm";

export default function Signup() {
  const { isLoggedIn, role } = useAuth()
  if(role!=='student') localStorage.clear();
  
  if (isLoggedIn && role == 'student') return <Navigate to={'/course'} replace={true} />

  return (
    <>
      <div>
        <img className="h-12 mx-auto" src="../assets/image/learningportal.svg" />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
          Create Your New Account
        </h2>
      </div>
      <SignupForm/>
    </>
  )
}